import { render, staticRenderFns } from "./LocalisedContentEditable.vue?vue&type=template&id=204a3e1d&scoped=true&"
import script from "./LocalisedContentEditable.vue?vue&type=script&lang=js&"
export * from "./LocalisedContentEditable.vue?vue&type=script&lang=js&"
import style0 from "./LocalisedContentEditable.vue?vue&type=style&index=0&id=204a3e1d&lang=scss&scoped=true&"
import style1 from "./LocalisedContentEditable.vue?vue&type=style&index=1&id=204a3e1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204a3e1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems,VTextarea})
